<template>
    <div>
        <h2>My Invoices</h2>
        <vs-divider/>
        <vs-card>
            <div v-if="invoicesLoading">Loading invoices...</div>
            <div v-if="invoicesError">{{invoicesError}}</div>
            
            <vs-table v-if="hasInvoices" max-items="5" pagination :data="invoices.data">
                <template v-slot:thead>
                    <vs-th>Invoice #</vs-th>
                    <vs-th>Start Date</vs-th>
                    <vs-th>End Date</vs-th>
                    <vs-th>Description</vs-th>
                    <vs-th style="min-width: 90px">Amount</vs-th>
                    <vs-th>Actions</vs-th>
                </template>
                <template v-slot="{data}">
                    <slot v-for="invoice in data">
                        <slot v-for="invoice_line in invoice.lines.data">
                            <vs-tr :key="invoice_line.id">
                                <vs-td>{{invoice.number}}</vs-td>
                                <vs-td>{{formatDate(invoice_line.period.start)}}</vs-td>
                                <vs-td>{{formatDate(invoice_line.period.end)}}</vs-td>
                                <vs-td>{{invoice_line.description}}</vs-td>
                                <vs-td>{{(invoice_line.amount / 100) + ' ' + invoice.currency}}</vs-td>
                                <vs-td></vs-td>
                            </vs-tr>
                        </slot>
                        <vs-tr :key="invoice.id" class="grand-total-row">
                            <vs-td>{{invoice.number}}</vs-td>
                            <vs-td colspan=3 class="grand-total-title"><b>Grand Total</b></vs-td>
                            <vs-td><span><b>{{((invoice.amount_paid + invoice.amount_remaining) / 100)}}</b></span><span> {{invoice.currency}}</span>
                                <div v-if="invoice.paid" style="color: green">PAID</div>
                                <div v-else style="color: red">Amount due: {{(invoice.amount_due / 100) + ' ' + invoice.currency}}</div>
                            </vs-td>
                            <vs-td>
                                <vs-chip class="action-item" color="primary"><a style="color: #fff" :href="invoice.hosted_invoice_url" target="_blank">View Invoice Details</a></vs-chip>
                            </vs-td>
                        </vs-tr>
                    </slot>
                </template>
            </vs-table>
            <div v-if="!hasInvoices && !invoicesLoading && !invoicesError">No invoices found.</div>
        </vs-card>
    </div>
</template>

<script>
import helperMethods from '../mixins/helperMethods'
import { getStripeInvoices } from '../stripe/stripeHelperMethods'

export default {
    name: 'Invoices',
    mixins: [
        helperMethods
    ],
    data() {
        return {
            invoices: {},
            hasInvoices: false,
            invoicesLoading: false,
            invoicesError: ''
        }
    },
    mounted() {
        if (!this.hasData(this.$store.state.AppActiveUser.stripeInvoices) && this.$store.state.AppActiveUser.stripe_id) {
            this.loadInvoices(this.$store.state.AppActiveUser.stripe_id)
        } else {
            this.invoices = this.$store.state.AppActiveUser.stripeInvoices
            this.hasInvoices = this.hasData(this.invoices)
        }
    },
    methods: {
        loadInvoices(stripeCustomerId) {
            this.invoicesLoading = true;

            getStripeInvoices(stripeCustomerId)
                .then (result => {
                    //console.log('invoices GET result:', result)
                    this.invoices = result.data;
                    this.hasInvoices = this.hasData(this.invoices)
                    this.$store.commit('UPDATE_USER_INFO', { stripeInvoices: this.invoices, hasInvoices: this.hasInvoices }, { root: true })
                }).catch(err => {
                    this.invoicesError = 'Error occured while fetching invoices: ' + err.response.data.raw.message;
                    this.hasInvoices = false;
                }).finally(() => {
                    this.invoicesLoading = false;
                })
        }
    }
}
</script>
<style scoped>
.grand-total-row {
    background: #f7f7f7;
}
.grand-total-title {
    text-align: right;
}
.action-item {
    text-align: center;
}
</style>